module.exports = __webpack_public_path__ + "static/nav-background-dark-sq-096500574b083fb8686777623e600530.png";